<template>
  <div class="flex flex-1 justify-end items-center text-black font-bold text-base topbar-profile-card-container">
    <span
      ref="profileCardName"
      class="cursor-pointer semi-bold-font uppercase"
      @click="onMouseClick"
    >
      {{ user.name }}
      <i class="ml-4 text-lg fa fa-angle-down text-primary" />
    </span>

    <div
      v-if="showCard"
      ref="profileCard"
      class="topbar-profile-card shadow"
    >
      <div class="profile-row w-full flex flex-1 border-b border-grey-light">
        <div
          :class="{'mb-2': isAdmiralAdmin}"
          class="w-1/3 flex items-center"
        >
          <avatar size="xs" />
        </div>
        <div class="user-information w-2/3 flex flex-col">
          <span class="user-name mb-4 space-letters semi-bold-font uppercase">{{ user.name }}</span>
          <router-link
            v-if="!isAdmiralAdmin"
            to="/profile-management/profile"
            class="profile-link bg-primary text-white no-underline py-2 px-4 rounded"
          >My Profile</router-link>
        </div>
      </div>
      <div class="navigation-row mt-4 flex flex-col">
        <div
          v-if="!isActing"
          class="mt-2 text-black no-underline cursor-pointer hover:text-grey-darker"
          @click="logout"
        >Log Out</div>
        <div
          v-else
          class="mt-2 text-black no-underline cursor-pointer hover:text-grey-darker"
          @click="stopActing"
        >Stop Acting</div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '@components/custom/Avatar';
import config from '../../config';

export default {
  name: 'ProfileCard',
  components: { Avatar },
  props: {
    user: {
      type: Object,
      required: true,
    },
    isActing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCard: false,
    };
  },
  computed: {
    isAdmiralAdmin() {
      return this.user.roles.find(role => role.toLowerCase() === config.USER_ROLES.ADMIRAL_ADMIN.toLowerCase());
    },
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick(event) {
      const targetInCard = this.$refs.profileCard ? this.$refs.profileCard.contains(event.target) : false;
      const targetInCardName = this.$refs.profileCardName ? this.$refs.profileCardName.contains(event.target) : false;

      if (!this.showCard || (this.showCard && (targetInCard || targetInCardName))) {
        return;
      }

      this.showCard = false;
    },
    onMouseClick(event) {
      event.preventDefault();

      if (!this.showCard) {
        this.$nextTick(() => {
          this.showCard = true;
        });
      }
    },
    logout() {
      this.$emit('profile-logout');
    },
    stopActing() {
      this.$emit('stop-acting');
    },
  },
};
</script>
